import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-chunk-error-dialog',
  imports: [BaseModalComponent, TranslocoDirective],
  templateUrl: './chunk-error-dialog.component.html',
  styleUrl: './chunk-error-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChunkErrorDialogComponent {
  isOpen = input<boolean>(false);

  refreshClicked = output<void>();

  protected onRefresh(): void {
    this.refreshClicked.emit();
  }
}
